import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OSINTPost from './OSINTPost';
import OSINTMap from './OSINTMap';
import OSINTFilter from './OSINTFilter';
import OSINTAnalytics from './OSINTAnalytics';

import './OSINTPage.css';
import { fetchTwitterDataAction } from 'actions/osintActions';
import moment from 'moment';
import { endLoading, startLoading } from 'reducers/loading/loading.action';

import PageTitle from 'components/headers/PageTitle';

const TAB_DATA = [{ label: 'Posts', value: 'Posts' }];

export default function OSINTPage() {
  const reduxDispatch = useDispatch();
  const prevSearchTermRef = useRef(null);

  const reduxTwitterDataLoaded = useSelector((state) => {
    return state.app.isTwitterDataLoaded;
  });

  const [selectedTab, setSelectedTab] = useState(TAB_DATA[0].value);
  const [searchTerm, setSearchTerm] = useState('');
  const [numPosts, setNumPosts] = useState(10);
  const [selectedSources, setSelectedSources] = useState(['twitter']);
  const [includeKeywords, setIncludeKeywords] = useState('');
  const [excludeKeywords, setExcludeKeywords] = useState('');
  const [startTime, setStartTime] = useState(moment().subtract(1, 'day'));
  const [endTime, setEndTime] = useState(moment());

  useEffect(() => {
    prevSearchTermRef.current = searchTerm;
  }, [searchTerm]);

  function submitClicked() {
    if (searchTerm !== '') {
      reduxDispatch(
        fetchTwitterDataAction(
          searchTerm,
          numPosts,
          selectedSources,
          includeKeywords,
          excludeKeywords,
          startTime,
          endTime
        )
      );
    }
  }

  useEffect(() => {
    if (!reduxTwitterDataLoaded) {
      reduxDispatch(startLoading());
    } else {
      reduxDispatch(endLoading());
    }
  }, [reduxTwitterDataLoaded]);

  return (
    <>
      <div className="site-main">
        <div className="container-fluid">
          <PageTitle title="OSINT" />
          <div className="row">
            <div className="col-xl-3 order-1 order-xl-0">
              <OSINTFilter
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                numPosts={numPosts}
                setNumPosts={setNumPosts}
                selectedSources={selectedSources}
                setSelectedSources={setSelectedSources}
                includeKeywords={includeKeywords}
                setIncludeKeywords={setIncludeKeywords}
                excludeKeywords={excludeKeywords}
                setExcludeKeywords={setExcludeKeywords}
                startTime={startTime}
                setStartTime={setStartTime}
                endTime={endTime}
                setEndTime={setEndTime}
                submitClicked={submitClicked}
              />
            </div>

            <div className="col-xl-9 mb-4 mb-xl-0">
              {selectedTab === 'Posts' && (
                <OSINTPost searchTerm={searchTerm} numPosts={numPosts} />
              )}
              {selectedTab === 'Map' && <OSINTMap />}
              {selectedTab === 'Analytics' && <OSINTAnalytics />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
